/*
 * @Author: your name
 * @Date: 2021-06-22 11:18:15
 * @LastEditTime: 2021-06-22 19:15:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/api/user.js
 */
import request from '@/router/axios'
import { baseUrl } from '@/config/env'
import qs from 'qs'

export const loginByUsername = (tenantId, username, password, type, key, code, phone, verifyCode, isPhoneLogin = false) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    'Captcha-Key': key,
    'Captcha-Code': code,
  },
  params: {
    tenantId,
    username,
    password,
    phone,
    verifyCode,
    // grant_type: 'captcha',
    // grant_type: 'password',
    grant_type: isPhoneLogin ? 'sms_token' : 'extend_token',
    scope: 'all',
    type,
  },
})
export const loginByToken = (params) => request({

  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': params.tenantId,

  },
  params: {
    tenantId: params.tenantId,
    username: params.username,
    ssoToken: params.ssoToken,


    // grant_type: 'captcha',
    // grant_type: 'password',
    grant_type: params.grant_type,
    scope: 'all',
    type: params.type,
  },
})

export const loginByAiisToken = params => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': '00000',
  },
  data: qs.stringify(params),
})

export const refreshToken = (token, tenantId) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
  },
  params: {
    tenantId,
    token,
    grant_type: 'refresh_token',
    scope: 'all',
  },
})

// 不依赖token 修改密码接口
export const updatePasswordNoToken = (params, headers) => request({
  url: '/api/blade-user/update-password',
  method: 'post',
  headers,
  params,
})

export const getButtons = () => request({
  url: '/api/blade-system/menu/buttons',
  method: 'get',
})
export const sendLoginSms = (params) => request({
  url: '/api/mcc-open/openLogin/sendLoginSms',
  method: 'post',
  data: params
})
export const checkV2Version = (params) => request({
  url: '/api/mcc-open/openAppVersion/checkV2',
  method: 'post',
  params: params
})

export const sendForgetPasswordSms = (params) => request({
  url: '/api/mcc-open/openLogin/sendResetPasswordSms',
  method: 'post',
  data: params
})
export const sendResetPasswordEmail = (params) => request({
  url: '/api/mcc-open/openLogin/sendResetPasswordEmail',
  method: 'post',
  data: params
})
export const resetPasswordByEmail = (params) => request({
  url: '/api/mcc-open/openLogin/resetPasswordByEmail',
  method: 'post',
  data: params
})
export const resetPasswordBySms = (params) => request({
  url: '/api/mcc-open/openLogin/resetPasswordBySms',
  method: 'post',
  data: params
})
export const getCaptcha = () => request({
  url: '/api/blade-auth/oauth/captcha',
  method: 'get',
})

export const getUserInfo = () => request({
  url: '/api/blade-user/info',
  method: 'get',
})

export const getUserAllInfo = () => request({
  url: '/api/blade-user/all-info',
  method: 'get',
})

export const sendLogs = list => request({
  url: `${baseUrl}/user/logout`,
  method: 'post',
  data: list,
})

export const logout = () => request({
  url: '/api/blade-auth/oauth/logout',
  method: 'get',
})

export const getProjects = params => request({
  url: '/api/qcdm/project/jurisdiction/loginProjectList',
  method: 'get',
  meta: {
    doNotAddProjectId: true,
  },
  params,
})

export const getParam = params => request({
  url: '/api/blade-system/param/list',
  method: 'get',
  params,
})

export const loginBySocial = params => request({
  url: '/api/blade-system/param/list',
  method: 'get',
  params,
})

export const updatePassword = params => request({
  url: '/api/blade-user/update-password',
  method: 'post',
  params,
})

export const resetPassword = params => request({
  url: '/api/blade-user/resetPassword1',
  method: 'post',
  params,
})

export const ItFeedbackSave = params => request({
  url: '/api/blade-user/userFeedback/save',
  method: 'post',
  data: params,
})

export const ItSearch = (current, size, params) => request({
  url: '/api/blade-user/userFeedback/search',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  }
})
export const ItFeedbackRemove = params => request({
  url: '/api/blade-user/userFeedback/remove',
  method: 'post',
  data: params,
})
export const ItFeedbackProcess = params => request({
  url: '/api/blade-user/userFeedback/process',
  method: 'post',
  data: params,
})
export const ItFeedbackClose = params => request({
  url: '/api/blade-user/userFeedback/close',
  method: 'post',
  data: params,
})